
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.3 10.7H4.31c-.83 0-1.5.67-1.5 1.5v2.97c0 .82.67 1.5 1.5 1.5h2.97c.83 0 1.5-.68 1.5-1.5v-2.98c0-.82-.67-1.5-1.5-1.5zm.5 4.47a.5.5 0 01-.5.5H4.31a.5.5 0 01-.5-.5v-2.98c0-.27.22-.5.5-.5h2.97c.28 0 .5.23.5.5v2.98zm7.92-4.47h-4.65a.5.5 0 000 1h4.65a.5.5 0 000-1zm-.93 2.48h-3.72a.5.5 0 000 1h3.72a.5.5 0 000-1zm-.93 2.49h-2.79a.5.5 0 000 1h2.8a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M22.33 3.76h-3.16V2.74c0-1.07-.87-1.94-1.94-1.94H1.9A1.9 1.9 0 000 2.7v18.32c0 1.2.98 2.18 2.18 2.18h18.57l.78-.01a2.54 2.54 0 002.47-2.6V5.42c0-.92-.75-1.67-1.67-1.67zM2.18 22.2c-.65 0-1.18-.53-1.18-1.18V2.7c0-.5.4-.9.9-.9h15.34c.51 0 .93.41.93.93v17.85c0 .6.21 1.16.56 1.6H2.18zM23 20.58c0 .89-.66 1.6-1.48 1.6l-.78.02c-.83 0-1.57-.75-1.57-1.61V4.76h3.16c.37 0 .67.3.67.67V20.6z"}}),_c('path',{attrs:{"d":"M15.72 7.27H3.36a.5.5 0 000 1h12.36a.5.5 0 000-1z"}})])
          )
        }
      }
    